{
  "id": "vehicle",
  "text": "CORNER_CRUSH \u00b7 LOGGED",
  "variant": "flag",
  "src": "/proof/video/vehicle.mp4",
  "poster": "/proof/video/vehicle-poster.jpg",
  "posterTime": 4.5,
  "duration": 6.0,
  "fps": 24.0,
  "keyframes": [
    {
      "t": 0.0,
      "top": 0.5087,
      "left": 0.1508,
      "width": 0.3584,
      "height": 0.3216
    },
    {
      "t": 0.5,
      "top": 0.5141,
      "left": 0.1454,
      "width": 0.3576,
      "height": 0.3209
    },
    {
      "t": 1.0,
      "top": 0.5205,
      "left": 0.1548,
      "width": 0.3571,
      "height": 0.3204
    },
    {
      "t": 1.5,
      "top": 0.5216,
      "left": 0.1596,
      "width": 0.3563,
      "height": 0.3197
    },
    {
      "t": 2.0,
      "top": 0.5149,
      "left": 0.1596,
      "width": 0.3557,
      "height": 0.3192
    },
    {
      "t": 2.5,
      "top": 0.5099,
      "left": 0.167,
      "width": 0.3559,
      "height": 0.3194
    },
    {
      "t": 3.0,
      "top": 0.511,
      "left": 0.1698,
      "width": 0.3561,
      "height": 0.3195
    },
    {
      "t": 3.5,
      "top": 0.5134,
      "left": 0.1581,
      "width": 0.3567,
      "height": 0.3201
    },
    {
      "t": 4.0,
      "top": 0.5149,
      "left": 0.1525,
      "width": 0.3575,
      "height": 0.3208
    },
    {
      "t": 4.5,
      "top": 0.5164,
      "left": 0.1532,
      "width": 0.3581,
      "height": 0.3213
    },
    {
      "t": 5.0,
      "top": 0.5177,
      "left": 0.1456,
      "width": 0.3591,
      "height": 0.3222
    },
    {
      "t": 5.5,
      "top": 0.516,
      "left": 0.146,
      "width": 0.3598,
      "height": 0.3229
    },
    {
      "t": 5.958,
      "top": 0.5109,
      "left": 0.1569,
      "width": 0.3598,
      "height": 0.3229
    }
  ]
}
